"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSF = void 0;
function viewSF() {
    var _this = this;
    var view = {
        constructor: function (props) {
            _this.getStepLocalizedText = view.getStepLocalizedText.bind(_this);
            _this.setStepLocalizedText = view.setStepLocalizedText.bind(_this);
            _this.state = {
                stepLocalizedText: _this.getStepLocalizedText(props)
            };
        },
        getStepLocalizedText: function (_a) {
            var currentPage = _a.currentPage, totalPages = _a.totalPages, StepText = _a.StepText;
            return StepText.replace("{0}", currentPage).replace("{1}", totalPages);
        },
        setStepLocalizedText: function (props) {
            _this.setState({
                stepLocalizedText: _this.getStepLocalizedText(props),
            });
        },
        mounted: function () {
            _this.setStepLocalizedText(_this.props);
        },
        willReceiveProps: function (newProps) {
            var _a = _this.props, currentPage = _a.currentPage, totalPages = _a.totalPages;
            var nextPage = newProps.currentPage, updatedTotalPages = newProps.totalPages;
            if (currentPage !== nextPage || totalPages != updatedTotalPages) {
                _this.setStepLocalizedText(newProps);
            }
        },
        events: {}
    };
    return view;
}
exports.viewSF = viewSF;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/8b1685a0cde68c49/src/.tmp/ApplicationWorkflowStepProgress/ViewSF.js
// module id = 558
// module chunks = 0